if (typeof p80 === typeof undefined) {
	var p80 = {};
}

p80.ajaxCart = function (config) {
	this.showCartButtons = document.querySelectorAll('[data-toggle-cart]');
	this.container = document.getElementById('ajax-cart');
	this.priceDisplay = this.container.querySelector('[data-ajax-cart-price]');
	this.hasProductsContainer = this.container.querySelector('.ajax-cart__has-products');
	this.noProductsContainer = this.container.querySelector('.ajax-cart__no-products');
	this.primaryProductDisplay = this.container.querySelector('[data-ajax-cart-primary-products]');
	this.productTemplate = document.getElementById('ajax-cart-product-template');
	if (this.productTemplate) {
		this.productTemplate = this.productTemplate.cloneNode(true);
		this.productTemplate.classList.remove('hidden');
		this.productTemplate.removeAttribute('id');
	}
	this.showMoreButton = this.container.querySelector('[data-ajax-cart-show-more]');
	this.spinnerSVG = `
        <svg class='spinner' viewBox='0 0 50 50'>
            <circle class='path' cx='25' cy='25' r='20' fill='none' stroke-width='5'></circle>
        </svg>
    `;
	this.isVisible = false;
	this.isUpdating = false;
	this.products = [];
	this.bind();
};

p80.ajaxCart.prototype.toggleCart = function () {
	const cart = this;
	if (this.isUpdating) return;
	if (cart.isVisible) {
		cart.container.classList.remove('active');
		document.querySelector('body').classList.remove('overflow-hidden');
		cart.isVisible = false;
	} else {
		cart.showLoaders();
		cart.fetchCart();
		cart.container.classList.add('active');
		document.querySelector('body').classList.add('overflow-hidden');
		cart.isVisible = true;
	}
};

p80.ajaxCart.prototype.showLoaders = function () {
	const cart = this;
	if (cart.priceDisplay) {
		cart.priceDisplay.innerHTML = this.spinnerSVG;
	}
	if (cart.primaryProductDisplay) {
		cart.primaryProductDisplay.innerHTML = this.spinnerSVG;
	}
	if (cart.secondaryProductDisplay) {
		cart.secondaryProductDisplay.innerHTML = this.spinnerSVG;
	}
};

p80.ajaxCart.prototype.showPriceLoader = function () {
	const cart = this;
	if (cart.priceDisplay) {
		cart.priceDisplay.innerHTML = this.spinnerSVG;
	}
};

p80.ajaxCart.prototype.fetchCart = function () {
	const cart = this;
	cart.products = [];
	fetch(window.Shopify.routes.root + 'cart.js', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.items) {
				cart.data = data;
				cart.generateCart();
				cart.updateTotal();
			} else {
				cart.data = null;
				cart.generateCart();
				cart.updateTotal();
			}
			if (p80.updateCartCount) {
				p80.updateCartCount(data.item_count);
			}
		})
		.catch((error) => {
			console.error('Error fetching cart:', error);
		});
};

p80.ajaxCart.prototype.generateCart = function () {
	const cart = this;
	cart.primaryProductDisplay.innerHTML = '';
	if (cart.data.items && cart.data.items.length) {
		for (var x = 0; x < cart.data.items.length; x++) {
			const cartItem = new p80.ajaxCartItem(cart, cart.data.items[x]);
			cart.products.push(cartItem);
			cart.primaryProductDisplay.appendChild(cartItem.html);
		}
		cart.hasProductsContainer.classList.remove('hidden');
		cart.noProductsContainer.classList.add('hidden');
	} else {
		cart.hasProductsContainer.classList.add('hidden');
		cart.noProductsContainer.classList.remove('hidden');
	}
};

p80.ajaxCart.prototype.updateTotal = function () {
	const cart = this;
	if (!cart.data.total_price) {
		cart.priceDisplay.innerHTML = '';
		cart.priceDisplay.innerText = '$0.00';
		const affirmHolder = document.querySelector("[data-page-type='cart']");
		if (!affirmHolder) return;
		affirmHolder.setAttribute('data-amount', 0.0);
		affirmHolder.style.display = 'none';
		const achievedMessaging = cart.container.querySelector('[data-rug-achieved]');
		const pendingMessaing = cart.container.querySelector('[data-rug-pending]');
		if (achievedMessaging) achievedMessaging.classList.add('hidden');
		if (pendingMessaing) pendingMessaing.classList.add('hidden');
		return;
	}

	cart.priceDisplay.innerHTML = '';
	let totalPrice = cart.data.total_price;
	totalPrice = totalPrice / 100;
	totalPrice = totalPrice.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
	totalPrice = totalPrice.replace(',', '');
	cart.priceDisplay.innerText = totalPrice;
	const enableFreeRug = cart.container.getAttribute('data-free-rug') == 'true' ? true : false;
	if (enableFreeRug) {
		const achievedMessaging = cart.container.querySelector('[data-rug-achieved]');
		const pendingMessaing = cart.container.querySelector('[data-rug-pending]');
		if (cart.data.total_price >= 100000) {
			if (achievedMessaging) achievedMessaging.classList.remove('hidden');
			if (pendingMessaing) pendingMessaing.classList.add('hidden');
		} else {
			if (achievedMessaging) achievedMessaging.classList.add('hidden');
			if (pendingMessaing) pendingMessaing.classList.remove('hidden');
		}
	} else {
		if (typeof affirm === typeof undefined) return;
		const affirmHolder = document.querySelector("[data-page-type='cart']");
		if (!affirmHolder) return;
		affirmHolder.setAttribute('data-amount', cart.data.total_price);
		affirm.ui.refresh();
		affirmHolder.style.display = 'block';
	}
};

p80.ajaxCart.prototype.bind = function () {
	const cart = this;
	if (cart.showCartButtons.length) {
		for (var x = 0; x < cart.showCartButtons.length; x++) {
			this.showCartButtons[x].addEventListener('click', function (e) {
				e.preventDefault();
				cart.toggleCart();
			});
		}
	}
	document.addEventListener('click', function (e) {
		if (cart.isVisible) {
			if (e.target !== cart.container && !cart.container.contains(e.target)) {
				if (
					e.target.hasAttribute('data-toggle-cart') ||
					e.target.parentElement.hasAttribute('data-toggle-cart')
				)
					return;
				cart.toggleCart();
			}
		}
	});
};

p80.ajaxCartItem = function (cart, data) {
	this.data = data;
	this.cart = cart;
	this.html = this.cart.productTemplate.cloneNode(true);
	this.image = this.html.querySelector('[data-ajax-cart-product-image]');
	this.title = this.html.querySelector('[data-ajax-cart-product-title]');
	this.subTitle = this.html.querySelector('[data-ajax-cart-product-subtitle]');
	this.price = this.html.querySelector('[data-ajax-cart-product-price]');
	this.quantityInput = this.html.querySelector('[data-ajax-cart-product-quantity]');
	this.quantityIncrease = this.html.querySelector('[data-ajax-cart-increase]');
	this.quantityDecrease = this.html.querySelector('[data-ajax-cart-decrease]');
	this.controls = this.html.querySelector('[data-ajax-cart-controls]');
	this.discounts = this.html.querySelector('[data-ajax-cart-product-discounts]');
	this.isUpdating = false;
	this.generateHtml();
	this.bind();
};

p80.ajaxCartItem.prototype.generateHtml = function () {
	const cartItem = this;
	cartItem.image.src = cartItem.data.image;
	cartItem.title.href = cartItem.data.url;
	let title = cartItem.data.title.split(' - ');
	if (title.length) {
		title = title[0].split(' in ');
		cartItem.title.innerText = title[0];
	} else {
		cartItem.title.innerText = cartItem.data.title;
	}
	cartItem.subTitle.innerText = cartItem.data.variant_title;
	let variantPrice = cartItem.data.final_price;
	if (variantPrice != 0) {
		variantPrice = variantPrice / 100;
		variantPrice = variantPrice.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
		variantPrice = variantPrice.slice(0, -3);
		variantPrice = variantPrice.replace(',', '');
		cartItem.price.innerText = variantPrice;
	} else {
		cartItem.price.innerText = 'Free';
	}
	cartItem.quantityInput.value = cartItem.data.quantity;
	if (cartItem.data.discounts.length > 0) {
		cartItem.discounts.innerHTML = '';
		for (var x = 0; x < cartItem.data.discounts.length; x++) {
			const discountLine = document.createElement('div');
			let discountPrice = cartItem.data.discounts[x].amount;
			discountPrice = discountPrice / 100;
			discountPrice = discountPrice.toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD'
			});
			discountPrice = discountPrice.slice(0, -3);
			discountPrice = discountPrice.replace(',', '');
			discountLine.innerText = `${cartItem.data.discounts[x].title} (-${discountPrice})`;
			cartItem.discounts.appendChild(discountLine);
		}
	}
};

p80.ajaxCartItem.prototype.bind = function () {
	const cartItem = this;
	cartItem.quantityIncrease.addEventListener('click', function (e) {
		e.preventDefault();
		cartItem.increaseQuantity();
	});
	cartItem.quantityDecrease.addEventListener('click', function (e) {
		e.preventDefault();
		cartItem.decreaseQuantity();
	});
	cartItem.quantityInput.addEventListener('change', function (e) {
		let value = e.target.value;
		value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
		if (value === '' || value < 0) value = 0;
		cartItem.data.quantity = parseInt(value, 10);
		cartItem.updateCartItem();
	});
	cartItem.quantityInput.addEventListener('input', function (e) {
		if (cartItem.isUpdating) {
			e.preventDefault();
			return;
		}
		let value = e.target.value;
		value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
		if (value === '' || value < 0) value = 0;
		cartItem.data.quantity = parseInt(value, 10);
	});
};

p80.ajaxCartItem.prototype.increaseQuantity = function () {
	const cartItem = this;
	if (cartItem.isUpdating) return;
	cartItem.data.quantity = cartItem.data.quantity + 1;
	cartItem.quantityInput.value = cartItem.data.quantity;
	cartItem.updateCartItem();
};

p80.ajaxCartItem.prototype.decreaseQuantity = function () {
	const cartItem = this;
	if (cartItem.isUpdating) return;
	if (cartItem.data.quantity <= 0) return;
	cartItem.data.quantity = cartItem.data.quantity - 1;
	cartItem.quantityInput.value = cartItem.data.quantity;
	cartItem.updateCartItem();
};

p80.ajaxCartItem.prototype.updateCartItem = function () {
	const cartItem = this;
	if (cartItem.isUpdating) return;
	cartItem.isUpdating = true;
	cartItem.disable();
	cartItem.cart.showPriceLoader();
	const variantId = cartItem.data.variant_id;
	const quantity = cartItem.data.quantity;
	const postData = {
		updates: {
			[variantId]: quantity
		}
	};
	fetch(window.Shopify.routes.root + 'cart/update.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(postData)
	})
		.then((response) => response.json())
		.then((data) => {
			cartItem.enable();
			if (data.items && data.items.length) {
				cartItem.cart.hasProductsContainer.classList.remove('hidden');
				cartItem.cart.noProductsContainer.classList.add('hidden');
				cartItem.cart.data = data;
				cartItem.cart.updateTotal();
				const newData = data.items.filter(function (item) {
					return item.variant_id === variantId;
				});
				if (newData.length) {
					cartItem.data = newData[0];
					cartItem.generateHtml();
				} else {
					cartItem.removeItem();
				}
			} else {
				cartItem.cart.data = data;
				cartItem.cart.updateTotal();
				cartItem.cart.hasProductsContainer.classList.add('hidden');
				cartItem.cart.noProductsContainer.classList.remove('hidden');
			}
			if (p80.updateCartCount) {
				p80.updateCartCount(data.item_count);
			}
		})
		.catch((error) => {
			cartItem.enable();
			console.error('Error fetching cart:', error);
		});
};

p80.ajaxCartItem.prototype.enable = function () {
	const cartItem = this;
	cartItem.isUpdating = false;
	cartItem.controls.classList.remove('disabled');
};

p80.ajaxCartItem.prototype.disable = function () {
	const cartItem = this;
	cartItem.isUpdating = true;
	cartItem.controls.classList.add('disabled');
};

p80.ajaxCartItem.prototype.removeItem = function () {
	const cartItem = this;
	const itemKey = cartItem.cart.products.findIndex((product) => {
		return product.data.variant_id === cartItem.data.variant_id;
	});
	if (itemKey >= 0) {
		cartItem.cart.products.splice(itemKey, 1);
		cartItem.html.remove();
	}
};
